import {useState} from 'react'
import {css} from '@emotion/react'
import {Radio} from 'antd'
import {SearchOutlined} from '@ant-design/icons'

const cssList = css({
    display: 'flex',
    flexDirection: 'column',
    fontSize: 'unset',
    overflow: 'auto',

    'label': {
        height: 'auto',
        fontSize: 'inherit',
        border: 'none !important',
    },
})

const cssMatched = css({
    backgroundColor: '#fbc02d',
})

const Label = ({
    children,
    indexes,
    listItem = a => a,
    nodeId,
    tree,
    ...props
}) => {
    const [title, setTitle] = useState('')
    const slices = []
    let l = 0

    for (const [i, j] of indexes) {
        slices.push(children.slice(l, i))
        slices.push(<span css={cssMatched}>{children.slice(i, j)}</span>)
        l = j
    }

    slices.push(children.slice(l))
    const node = tree.getNode(nodeId)

    const onMouseEnter = title ?
        void 0
        :
        () => {

            const title = [...tree.chain(node)]
                .reverse()
                .slice(1)
                .map(n => n.data.titleText ?? n.data.title)
                .join('➜')

            setTitle(title)
        }

    return (
        <div
            title={title}
            onMouseEnter={onMouseEnter}
            {...props}
        >
            {listItem(slices, node.data)}
        </div>
    )
}

const cssNotFound = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    gap: 12,
    fontSize: 14,
    color: '#afafaf',

    'svg': {
        fontSize: '4em',
    },
})

const NotFound = (props) => {
    return (
        <div
            css={cssNotFound}
            {...props}
        >
            <SearchOutlined />
            未找到结果
        </div>
    )
}

export const SearchList = ({listItem, matches, tree, onSelect, ...props}) => {
    const options = matches.map(
        ([key, text, indexes]) => ({
            label: (
                <Label
                    indexes={indexes}
                    listItem={listItem}
                    nodeId={key}
                    tree={tree}
                >
                    {text}
                </Label>
            ),

            value: key,
        })
    )

    const onChange = ({target: {value}}) => {
        onSelect(value)
    }

    return 0 < options.length ?
        <Radio.Group
            css={cssList}
            buttonStyle="solid"
            optionType="button"
            options={options}
            onChange={onChange}
            {...props}
        />
        :
        <NotFound />
}
